module.exports = __webpack_public_path__ + "static/media/form-textbox.0e1f9073.svg";